/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { accountActions } from '../../../actions';
import Spinners from '../../../components/Spinners';
import { withRouter } from '../../../helpers';
import './ForgotPassword.scss';
class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.updateInput = this.updateInput.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.showError = this.showError.bind(this);
    this.errorPopup = this.errorPopup.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.state = {
      cpassword: '',
      password: '',
      username: '',
      resetPassModal: false,
      otp: '',
      validatedRules: {},
      isValidationPopupWindowOpen: false,
    };
    this.otp = null;
  }

  showError(error) {
    switch (error.code) {
      case 'UserNotFoundException':
        this.setState({ error: 'User does not exist.' });
        break;
      case 'InvalidParameterException':
        this.setState({
          error:
            'Your account is not successfully setup. Please contact PriceKubecka to reset your account.',
        });
        break;
      default:
        this.setState({ error: error.message });
        break;
    }
  }

  errorPopup(errorMessage) {
    this.setState({
      otpError: errorMessage,
    });
  }

  resetPassword() {
    // Optimized regex to prevent ReDoS attacks - using atomic groups and simpler patterns
    let passRegx =
      /^(?=(?:[^a-z]*[a-z]){1})(?=(?:[^A-Z]*[A-Z]){1})(?=(?:[^0-9]*[0-9]){1})(?=(?:[^=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]){1})\S{8,99}$/;
    if (this.state.otp === '' || !this.state.otp) {
      this.errorPopup('OTP is required');
      return;
    }
    if (this.state.password === '' || !this.state.password) {
      this.errorPopup('New password is required');
      return;
    } else if (!passRegx.test(this.state.password)) {
      this.errorPopup(
        'Your password must be Minimum eight characters, Maximum ninety-nine characters, at least one uppercase letter, one lowercase letter, one number and one special character'
      );
      return;
    }
    if (this.state.cpassword === '' || !this.state.cpassword) {
      this.errorPopup('Confirm new password is required');
      return;
    } else if (this.state.password !== this.state.cpassword) {
      this.errorPopup('Password does not match.');
      return;
    }

    this.props.resetPassword(this.state.username, this.otp, this.state.password, (err) => {
      if (!err) {
        this.setState({ passwordResetSuccessful: true });
      } else {
        this.setState({ otpError: 'OTP verfication failed' });
      }
    });
  }

  forgotPassword(e) {
    e.preventDefault();
    if (this.state.username === '' || !this.state.username) {
      this.setState({ error: 'Email Address is required.' });
      return;
    }
    this.props.forgotPassword(this.state.username, (error) => {
      if (!error) {
        this.setState({ resetPassModal: true, error: '' });
      } else {
        this.showError(error);
      }
    });
  }

  updateInput(e) {
    switch (e.target.id) {
      case 'username':
        this.setState({
          username: e.target.value,
        });
        break;
      case 'password': {
        let validationPassword = this.matchExpression(e.target.value);
        this.setState({
          password: e.target.value,
          validatedRules: validationPassword,
          isValidationPopupWindowOpen: true,
        });
        break;
      }
      case 'otp':
        this.otp = e.target.value;
        this.setState({
          otp: e.target.value,
        });
        break;
      case 'cpassword':
        this.setState({
          cpassword: e.target.value,
        });
        break;
      default:
        break;
    }
  }

  handleInputFocus() {
    this.setState(prevState => ({
      isValidationPopupWindowOpen: !prevState.isValidationPopupWindowOpen,
    }));
  }

  matchExpression(passwordStr) {
    // Optimized regex patterns to prevent ReDoS attacks
    let rgularExp = {
      minEightChar: passwordStr.length >= 8,
      containsNumber: /[0-9]/,
      containsLowercaseLetter: /[a-z]/,
      containsUppercaseLetter: /[A-Z]/,
      containsSpecialChar: /[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]/,
      lessThanNintyNine: passwordStr.length <= 99,
    };

    let expMatch = {};
    expMatch.minEightChar = rgularExp.minEightChar;
    expMatch.containsNumber = rgularExp.containsNumber.test(passwordStr);
    expMatch.containsLowercaseLetter = rgularExp.containsLowercaseLetter.test(passwordStr);
    expMatch.containsUppercaseLetter = rgularExp.containsUppercaseLetter.test(passwordStr);
    expMatch.containsSpecialChar = rgularExp.containsSpecialChar.test(passwordStr);
    expMatch.lessThanNintyNine = rgularExp.lessThanNintyNine;
    return expMatch;
  }

  render() {
    let { validatedRules, isValidationPopupWindowOpen } = this.state;
    return (
      <div id="ForgotPasswordPage">
        <div className="headerPane">
          <div className="blueColorbox"></div>
          <img className="headerLogo" src="images/logo1.svg" />
          <div className="Heading">
            <b>
              THE BETTER WAY
              <br />
              TO DO EBP AUDITS
            </b>
          </div>
        </div>
        {this.props.loader ? <Spinners /> : ''}
        <div className="row m-0" id="signin">
          <div className="d-flex justify-content-center">
            {this.state.resetPassModal ? (
              <div className="form">
                <div className="form-row form-group">
                  <div className="col-12"></div>
                </div>
                <div className="form-row form-group">
                  <div className="col-10 offset-md-1">
                    {this.state.otpError && (
                      <Alert align="center" color="danger">
                        {this.state.otpError}
                      </Alert>
                    )}
                    {this.state.passwordResetSuccessful ? (
                      <div style={{ 'text-align': 'center' }}>
                        <Alert align="center" color="info">
                          Your password has been successfully reset. You may now log in using your
                          new password.
                        </Alert>
                        <Button
                          className="loginButton"
                          size="sm"
                          style={{
                            backgroundColor: '#bfb03d',
                            border: '1px solid #bfb03d',
                          }}
                          onClick={() => this.props.navigate('/login')}
                        >
                          Proceed to Login
                        </Button>
                      </div>
                    ) : isValidationPopupWindowOpen ? (
                      <div className="d-flex justify-content-center align-items-center notification-window">
                        <div className="d-flex justify-content-center align-items-center forget-password-message">
                          <div className="popup">
                            <span
                              style={{
                                width: '350px',
                                display: 'flex',
                                flexFlow: 'column',
                              }}
                            >
                              <span
                                className={
                                  'list ' + (validatedRules.minEightChar ? ' valid ' : ' invalid')
                                }
                              >
                                <img
                                  className={'validation-icons'}
                                  src={
                                    './images/' +
                                    (validatedRules.minEightChar ? 'Correct_Mark.png' : 'close.png')
                                  }
                                  style={{
                                    verticalAlign: 'baseline',
                                    marginRight: '5px',
                                  }}
                                />
                                Minimum 8 characters.
                              </span>
                              <span
                                className={
                                  'list ' +
                                  (validatedRules.containsNumber &&
                                  validatedRules.containsSpecialChar
                                    ? ' valid '
                                    : ' invalid')
                                }
                              >
                                <img
                                  className={'validation-icons'}
                                  src={
                                    './images/' +
                                    (validatedRules.containsNumber &&
                                    validatedRules.containsSpecialChar
                                      ? 'Correct_Mark.png'
                                      : 'close.png')
                                  }
                                  style={{
                                    verticalAlign: 'baseline',
                                    marginRight: '5px',
                                  }}
                                />
                                At least 1 number and 1 special character
                              </span>
                              <span
                                className={
                                  'list ' +
                                  (validatedRules.containsUppercaseLetter &&
                                  validatedRules.containsLowercaseLetter
                                    ? ' valid '
                                    : ' invalid')
                                }
                              >
                                <img
                                  className={'validation-icons'}
                                  src={
                                    './images/' +
                                    (validatedRules.containsUppercaseLetter &&
                                    validatedRules.containsLowercaseLetter
                                      ? 'Correct_Mark.png'
                                      : 'close.png')
                                  }
                                  style={{
                                    verticalAlign: 'baseline',
                                    marginRight: '5px',
                                  }}
                                />
                                At least 1 uppercase letter and 1 lowercase letter.
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : this.state.error ? (
                      <Alert align="center" color="danger">
                        {this.state.error}
                      </Alert>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center notification-window">
                        <div className="d-flex justify-content-center align-items-center forget-password-message">
                          <span style={{ width: '350px' }}>
                            Please enter the OTP you received at {this.state.username} and create a
                            new password.
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {!this.state.passwordResetSuccessful && (
                  <div>
                    <div className="form-row form-group" style={{ marginBottom: '0px' }}>
                      <div className="col-10 offset-md-1">
                        {this.state.error && (
                          <Alert align="center" color="danger">
                            {this.state.error}
                          </Alert>
                        )}
                      </div>
                    </div>
                    <div className="form-row form-group">
                      <div className="col-10 offset-md-1">
                        <p className="text-left label">OTP</p>
                      </div>
                      <div className="col-10 offset-md-1">
                        <div className="input-group">
                          <input
                            className="form-control13"
                            onChange={this.updateInput}
                            type="text"
                            id="otp"
                            placeholder="Enter OTP "
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row form-group">
                      <div className="col-10 offset-md-1">
                        <p className="text-left label">New Password</p>
                      </div>
                      <div className="col-10 offset-md-1">
                        <div className="input-group">
                          <input
                            className="form-control13"
                            onChange={this.updateInput}
                            type="password"
                            id="password"
                            placeholder="Enter New Password  "
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row form-group">
                      <div className="col-10 offset-md-1">
                        <p className="text-left label">Confirm New Password</p>
                      </div>
                      <div className="col-10 offset-md-1">
                        <div className="input-group">
                          <input
                            className="form-control13"
                            onChange={this.updateInput}
                            type="password"
                            id="cpassword"
                            placeholder="Confirm New Password  "
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row form-group lcs3 verifyButtonRow">
                      <a
                        style={{
                          height: '37px',
                          lineHeight: '37px',
                          textDecoration: 'underline',
                          color: '#2196F3',
                          cursor: 'pointer',
                        }}
                        onClick={this.forgotPassword}
                      >
                        Resend
                      </a>
                      <Button
                        className="button m-0"
                        size="sm"
                        style={{ backgroundColor: '#bfb03d', border: '1px solid #bfb03d' }}
                        onClick={() => {
                          this.setState({ otpError: '' }, () => {
                            this.resetPassword();
                          });
                        }}
                      >
                        RESET PASSWORD
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <form className="form" onSubmit={this.forgotPassword}>
                <div className="form-row form-group">
                  <div className="col-12" style={{ height: '30px' }}></div>
                </div>
                <div className="form-row form-group">
                  <div className="col-10 offset-md-1">
                    <div className="d-flex justify-content-center align-items-center notification-window">
                      <div className="d-flex justify-content-center align-items-center forget-password-message">
                        <p className="text-center fcs2">
                          Please enter the email associated with your account.
                          <br />
                          We will send an OTP to your email for password reset.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-row form-group">
                  <div className="col-10 offset-md-1">
                    {this.state.error && (
                      <Alert align="center" color="danger">
                        {this.state.error}
                      </Alert>
                    )}
                  </div>
                </div>
                <div className="form-row form-group">
                  <div className="col-10 offset-md-1">
                    <p className="text-left label">Email Address</p>
                  </div>
                  <div className="col-10 offset-md-1">
                    <div className="input-group">
                      <input
                        className="form-control13"
                        type="email"
                        onChange={this.updateInput}
                        id="username"
                        requred
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row form-group lcs3 loginButtonRow">
                  <Button
                    className="loginButton"
                    style={{ background: '#bfb03d', border: '1px solid #bfb03d' }}
                    size="sm"
                    type="submit"
                  >
                    Send
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loader } = state;
  return {
    loader,
  };
}

ForgotPassword.propTypes = {
  forgotPassword: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (username, otp, password, callback) =>
    dispatch(accountActions.resetPassword(username, otp, password, callback)),
  forgotPassword: (username, callback) =>
    dispatch(accountActions.forgotPassword(username, callback)),
});

// Export unwrapped component and mappers for testing
export { ForgotPassword as UnwrappedForgotPassword, mapStateToProps, mapDispatchToProps };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword));
